export enum AreaDimension {
    Two = "Two",
    Three = "Three"
}